// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding_form__Xxh9N {
  margin: 20px 0;
}
.onboarding_form__Xxh9N .onboarding_formGroup__harq8 {
  margin-bottom: 12px;
  position: relative;
}
.onboarding_form__Xxh9N .onboarding_eyeIcon__GxVGa {
  cursor: pointer;
  background-color: red;
}
.onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs,
.onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx,
.onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 12px 0;
}
.onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs .onboarding_forgotPassword__pZY1E,
.onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx .onboarding_forgotPassword__pZY1E,
.onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9 .onboarding_forgotPassword__pZY1E {
  font: var(--body-font-two);
  color: var(--primary-color);
  cursor: pointer;
}
.onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs button,
.onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx button,
.onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9 button {
  min-width: 120px;
  min-height: 42px;
  text-transform: capitalize;
  box-shadow: unset;
}
.onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs.onboarding_signInBtn__wp3fx, .onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs.onboarding_skipBtn__Obmm9,
.onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx.onboarding_signInBtn__wp3fx,
.onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx.onboarding_skipBtn__Obmm9,
.onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9.onboarding_signInBtn__wp3fx,
.onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9.onboarding_skipBtn__Obmm9 {
  justify-content: space-between;
}
.onboarding_form__Xxh9N .onboarding_or__i8Dax {
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  margin: 20px 0;
  position: relative;
}
.onboarding_form__Xxh9N .onboarding_or__i8Dax p {
  font: var(--body-font-three);
  color: #8692a4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: capitalize;
  background-color: #faf4f2;
  padding: 0px 10px;
  text-align: center;
}
.onboarding_form__Xxh9N .onboarding_socialLoginBtns__iCPzO {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}
.onboarding_form__Xxh9N .onboarding_socialLoginBtns__iCPzO button {
  min-height: 36px;
  box-shadow: unset;
  text-transform: capitalize;
  font: var(--body-font-three);
  font-weight: 500;
}
.onboarding_form__Xxh9N .onboarding_socialLoginBtns__iCPzO button img,
.onboarding_form__Xxh9N .onboarding_socialLoginBtns__iCPzO button svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
}

.onboarding_form__Xxh9N h1 {
  font: var(--h3);
  font-family: var(--font-bodoni);
  text-align: center;
}
.onboarding_form__Xxh9N p,
.onboarding_form__Xxh9N .onboarding_semiHeading__s-Dn1 {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  text-align: center;
  margin-top: 8px;
  margin-bottom: 50px;
}

.onboarding_forgotPwSection__fee8e .onboarding_formContainer__OVorG {
  position: relative;
}
.onboarding_forgotPwSection__fee8e .onboarding_formContainer__OVorG .onboarding_titleContainer__HISWF {
  margin-bottom: 5px;
}
.onboarding_forgotPwSection__fee8e .onboarding_formContainer__OVorG h4 {
  font-family: var(--font-alex);
}

.onboarding_priceRange__kYBVb {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid var(--border);
  padding: 11px 12px;
  border-radius: 8px;
  background: var(--white);
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 22px;
}
.onboarding_priceRange__kYBVb input {
  max-width: max-content;
  width: fit-content;
  background: none;
  border: none;
  outline: none;
  text-align: center;
  padding: 0;
  margin: 0;
  text-align: center;
}

@media (max-width: 991px) {
  .onboarding_form__Xxh9N {
    margin: 15px 0;
  }
  .onboarding_form__Xxh9N .onboarding_formGroup__harq8 {
    margin-bottom: 10px;
  }
  .onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs,
  .onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx,
  .onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9 {
    margin: 10px 0;
  }
  .onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs button,
  .onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx button,
  .onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9 button {
    min-width: 120px;
    min-height: 30px;
  }
  .onboarding_form__Xxh9N .onboarding_or__i8Dax {
    margin: 20px 0;
  }
  .onboarding_form__Xxh9N .onboarding_or__i8Dax p {
    font-size: 12px;
  }
  .onboarding_form__Xxh9N .onboarding_socialLoginBtns__iCPzO {
    margin-top: 20px;
    gap: 10px;
  }
}
@media (max-width: 767px) {
  .onboarding_form__Xxh9N .onboarding_signUpBtn__oMsPs button,
  .onboarding_form__Xxh9N .onboarding_signInBtn__wp3fx button,
  .onboarding_form__Xxh9N .onboarding_skipBtn__Obmm9 button {
    min-height: 38px;
    min-width: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/onboardingCards/onboarding.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;AACC;EACC,mBAAA;EACA,kBAAA;AACF;AAEC;EACC,eAAA;EACA,qBAAA;AAAF;AAGC;;;EAGC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;;;EACC,0BAAA;EACA,2BAAA;EACA,eAAA;AACH;AAEE;;;EACC,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AAEH;AACE;;;;;EAEC,8BAAA;AAIH;AAAC;EACC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAEF;AAAE;EACC,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAEH;AAEC;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAF;AAEE;EACC,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;;AAQC;EACC,eAAA;EACA,+BAAA;EACA,kBAAA;AALF;AAQC;;EAEC,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AANF;;AAaC;EACC,kBAAA;AAVF;AAYE;EACC,kBAAA;AAVH;AAaE;EACC,6BAAA;AAXH;;AAgBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAbD;AAeC;EACC,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAbF;;AAiBA;EACC;IACC,cAAA;EAdA;EAgBA;IACC,mBAAA;EAdD;EAiBA;;;IAGC,cAAA;EAfD;EAiBC;;;IACC,gBAAA;IACA,gBAAA;EAbF;EAiBA;IACC,cAAA;EAfD;EAiBC;IACC,eAAA;EAfF;EAmBA;IACC,gBAAA;IACA,SAAA;EAjBD;AACF;AAqBA;EAKG;;;IACC,gBAAA;IACA,gBAAA;EArBF;AACF","sourcesContent":[".form {\r\n\tmargin: 20px 0;\r\n\r\n\t.formGroup {\r\n\t\tmargin-bottom: 12px;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t.eyeIcon {\r\n\t\tcursor: pointer;\r\n\t\tbackground-color: red;\r\n\t}\r\n\r\n\t.signUpBtn,\r\n\t.signInBtn,\r\n\t.skipBtn {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\talign-items: center;\r\n\t\tmargin: 12px 0;\r\n\r\n\t\t.forgotPassword {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tcolor: var(--primary-color);\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\r\n\t\tbutton {\r\n\t\t\tmin-width: 120px;\r\n\t\t\tmin-height: 42px;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbox-shadow: unset;\r\n\t\t}\r\n\r\n\t\t&.signInBtn,\r\n\t\t&.skipBtn {\r\n\t\t\tjustify-content: space-between;\r\n\t\t}\r\n\t}\r\n\r\n\t.or {\r\n\t\twidth: 100%;\r\n\t\theight: 1px;\r\n\t\tbackground-color: #e5e5e5;\r\n\t\tmargin: 20px 0;\r\n\t\tposition: relative;\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: #8692a4;\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 50%;\r\n\t\t\ttransform: translate(-50%, -50%);\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbackground-color: #faf4f2;\r\n\t\t\tpadding: 0px 10px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t.socialLoginBtns {\r\n\t\tmargin-top: 25px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: center;\r\n\t\tgap: 15px;\r\n\r\n\t\tbutton {\r\n\t\t\tmin-height: 36px;\r\n\t\t\tbox-shadow: unset;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n//\r\n.form {\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-family: var(--font-bodoni);\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\tp,\r\n\t.semiHeading {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\ttext-align: center;\r\n\t\tmargin-top: 8px;\r\n\t\tmargin-bottom: 50px;\r\n\t}\r\n}\r\n\r\n//\r\n\r\n.forgotPwSection {\r\n\t.formContainer {\r\n\t\tposition: relative;\r\n\r\n\t\t.titleContainer {\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t}\r\n\r\n\t\th4 {\r\n\t\t\tfont-family: var(--font-alex);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.priceRange {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 8px;\r\n\tborder: 1px solid var(--border);\r\n\tpadding: 11px 12px;\r\n\tborder-radius: 8px;\r\n\tbackground: var(--white);\r\n\twidth: fit-content;\r\n\tmargin: 0 auto;\r\n\tmargin-bottom: 22px;\r\n\r\n\tinput {\r\n\t\tmax-width: max-content;\r\n\t\twidth: fit-content;\r\n\t\tbackground: none;\r\n\t\tborder: none;\r\n\t\toutline: none;\r\n\t\ttext-align: center;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\ttext-align: center;\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.form {\r\n\t\tmargin: 15px 0;\r\n\r\n\t\t.formGroup {\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t}\r\n\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tmargin: 10px 0;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-width: 120px;\r\n\t\t\t\tmin-height: 30px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.or {\r\n\t\t\tmargin: 20px 0;\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.socialLoginBtns {\r\n\t\t\tmargin-top: 20px;\r\n\t\t\tgap: 10px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.form {\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 38px;\r\n\t\t\t\tmin-width: unset;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `onboarding_form__Xxh9N`,
	"formGroup": `onboarding_formGroup__harq8`,
	"eyeIcon": `onboarding_eyeIcon__GxVGa`,
	"signUpBtn": `onboarding_signUpBtn__oMsPs`,
	"signInBtn": `onboarding_signInBtn__wp3fx`,
	"skipBtn": `onboarding_skipBtn__Obmm9`,
	"forgotPassword": `onboarding_forgotPassword__pZY1E`,
	"or": `onboarding_or__i8Dax`,
	"socialLoginBtns": `onboarding_socialLoginBtns__iCPzO`,
	"semiHeading": `onboarding_semiHeading__s-Dn1`,
	"forgotPwSection": `onboarding_forgotPwSection__fee8e`,
	"formContainer": `onboarding_formContainer__OVorG`,
	"titleContainer": `onboarding_titleContainer__HISWF`,
	"priceRange": `onboarding_priceRange__kYBVb`
};
export default ___CSS_LOADER_EXPORT___;
